<div class="calendar-box-big">
  <div class="calendar-box-big__month">
    {{ getMonthReduced() }}
  </div>
  <div class="calendar-box-big__day">
    {{ getDay() }}
  </div>
</div>
